<template>
    <search-group  @search="findData" @clear="clearValue" :span="24" :btnOffset="18" :btnSpan="6" :multipleLines="true" :inline="true" >
        <Row class="mb16" :gutter="16">
            <Col span="4">
              <Select v-model="searchData.projectFid" placeholder="项目名称" >
                <Option value=''>请选择</Option>
                <Option v-for="item in projectList" :value="item.value" :key="item.value">{{item.text}}</Option>
            </Select>
            </Col>
            <Col span="4">
              <Select v-model="searchData.contractState" placeholder="合同状态">
                <Option value=''>请选择</Option>
                <Option v-for="item in contractStateEnums" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
            </Col>
            <Col span="4">
              <Select v-model="searchData.subjectType" placeholder="客户类型">
                <Option value=''>请选择</Option>
                <Option v-for="item in customerTypes" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
            </Col>
            <Col span="4">
              <Select v-model="searchData.contractType" placeholder="签约类型">
                <Option value=''>请选择</Option>
                <Option v-for="item in contractSignTypes" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
            </Col>
            <Col span="4">
              <Select v-model="searchData.stockRentType" placeholder="出租方式">
                <Option value=''>请选择</Option>
                <Option v-for="item in stockRentTypes" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
            </Col>
            <Col span="4">
              <Select v-model="searchData.personDataStatus" placeholder="录入状态">
                <Option value=''>请选择</Option>
                <Option  v-for="item in enterStatusTypeEnums" :value="item.value" :key="item.value">{{item.text}}</Option>
              </Select>
            </Col>
            </Row>
             <Row :gutter="16">
            <Col span="6">
              <DatePicker style="width:100%" split-panels v-model="signDay" type="daterange" format="yyyy-MM-dd" @on-change="changesignDay" placeholder="签约日"></DatePicker>
            </Col>
            <Col span="6">
              <Input type="text" v-model="searchData.inputParam" placeholder="合同号、租客姓名、租客手机号、房间号" @keyup.enter.native="findData"></Input>
            </Col>
            <Col span="3">
                 <Select  v-model="searchData.hasSharer" placeholder="是否存在合租人" @keyup.enter.native="findData">
                     <Option value=''>请选择</Option>
                     <Option value='true'>是</Option>
                     <Option value='false'>否</Option>
                 </Select>
            </Col>
        </Row>
    </search-group>
</template>

<script type="text/ecmascript-6">
import {getProjects } from 'api/common'
import {getConditions} from 'api/occupancy'
import SearchGroup from 'components/SearchGroup/index';
export default {
    components: {
       SearchGroup
    },
    props:{

    },
    created(){
      this.initData()
    },
    data () {
      return {
        signDay:[],
        searchData: {
          projectFid:'',
          contractState:'',
          subjectType:'',
          contractType:'',
          stockRentType:'',
          personDataStatus:'',
          conSignDateStart:'',
          conSignDateEnd:'',
          inputParam:'',
          hasSharer: null,
          page: 1,
          limit: 10
        },
        projectList:[],
        contractSignTypes:[],
        contractStateEnums:[],
        customerTypes:[],
        enterStatusTypeEnums:[],
        stockRentTypes:[]
      }
    },
    methods: {
      findData() {
          this.$emit('searchData', this.searchData);
      },
      clearValue() {
        for (var key in this.searchData) {
          if(key === 'limit') continue
          if(key === 'page'){
            this.searchData[key] = 1
            continue;
          }
          this.searchData[key] = ''
          this.signDay = []
        }
      },
      changesignDay(val){
        this.searchData.conSignDateStart = val[0]
        this.searchData.conSignDateEnd  =val[1]

      },
      initData(){
          getProjects().then( res => {
            this.projectList = res.data
          })
          getConditions().then( res => {
            this.contractSignTypes = res.data.contractSignTypes
            this.contractStateEnums = res.data.contractStateEnums
            this.customerTypes = res.data.customerTypes
            this.enterStatusTypeEnums = res.data.enterStatusTypeEnums
            this.stockRentTypes = res.data.stockRentTypes
          })
        }
    }
}
</script>
